<template>
	<!-- 门店ID输入框组件 -->
	<div class="form-horizontal">
	  	<div class="form-group  has-feedback" 
	  		:class="{'has-success' : status == 1,'has-error' : status == -1}">
		    <div class="col-sm-8">
		      	<input type="text" class="form-control" placeholder="请输入门店ID"
		      		v-model="value"
		    		@blur="blur" 
    				@input="input">
		      	<span class="glyphicon glyphicon-ok form-control-feedback" v-if="status == 1"></span>
				<span class="glyphicon glyphicon-remove form-control-feedback" v-if="status == -1"></span>
		    </div>
	    	<label class="control-label col-sm-4  tl"  v-if="status == -1">{{errorTxt}}</label>
	    	<label class="control-label col-sm-4  tl"  v-if="status == 1">{{name}}</label>
	  	</div>
	</div>
</template>
<script>
	var Http = require('../../utils/HttpHelper.js');
	var Common = require('../../utils/Common.js');

	var query = function(vm) {
		Http.shop.queryOne({
			data : {id: vm.value},
			succ : function(rs){
				if(rs.name){					
					vm.isOK = true;
					vm.name = rs.name;
				}else{
					vm.isOK = false;
					vm.errorTxt = rs;
				}
			},
			err : function(){
				vm.isOK = false;
				vm.errorTxt = '没有对应的门店';
			}
		});
	}
	var VM = {
		timer : null,//定时器的纪录
		queryOne : function(comp){
			var self = this;
			if(this.timer){
				clearTimeout(this.timer);
			}
			this.timer = setTimeout(function(){		
				if(comp.isOK){		
					query(comp);					
				}
			},800);
		}
	};
	/**
		@param type 输入框的类型
		@param value 关联输入的内容 
		@param title 输入的标题
		@param min 不少于多少个字 默认为0
		@param max 不多于多少个字 默认为25
		@param must 标识是否是必填项 默认为true
	*/
	module.exports = {
		props : ['value'],
		data : function(){
			return {
				isOK : false, //标识验证是否通过		
				isActivated : false,//标识是否激活了判断
				name : '',//门店的NAME
				errorTxt : '没有对应的门店',
				/**
				* 验证是否通过验证
				*/
				isAdopt : function(){
					this.isActivated = true;//激活判断
					return this.isOK;
				},
				/**
				* 输入框的验证，是否是正整数
				*/
				verFunc : function(){
					if(Common.isMaxLen(this.value,0)){
						if(Common.isPositiveInt(Common.trim(this.value))){
							this.isOK = true;
							//进行数据的请求
							VM.queryOne(this);
						}else{							
							this.isOK = false;
							this.errorTxt = '请输入正确的ID';
						}
					}else{
						this.isOK = false;
						this.errorTxt = '请输入门店ID';
					}
				}
			}
		},
		ready : function(){
			if(this.value) {//如果id有值
				this.isActivated = true
				query(this);
			}
		},
		computed : {
			/**
			* 输入框的状态 -1:错误状态，0:正常状态,1正确状态
			*/
			status : function(){
				var num = 0;
				if(this.isActivated){
					num = this.isOK ? 1 : -1; 
				}
				return num;
			}
		},
		methods : {
			/**
			* 失去焦点
			*/
			blur : function(){
				if(!this.isActivated){
					this.isActivated = true;//激活判断
				}
				//验证的判断
				this.verFunc();
			},
			/**
			* 输入的监听
			*/
			input : function(){
				//移除两边的空格，并过滤特殊字符
				this.name = Common.stripscript(Common.trim(this.value));
				//非正常状态，进入输入验证
				// if(this.status != 0){					
				// 	this.verFunc();
				// }
				if(!this.isActivated){
					this.isActivated = true;//激活判断
				}
				this.verFunc();
			}
		}
	};
</script>


/** WEBPACK FOOTER **
 ** ShopID.vue?27f96b9c
 **/